export default {
  websocket: {
    'zh-CN':'中文',
    'toggle':'切换语言',
    'en-us':'英文',
    sync:'同步',
    init:'初始化',
    subSuccess:'订阅成功',
    path:'路径',
    connect: '连接',
    host: '主机地址',
    port: '端口',
    clientID: '客户端 ID',
    username: '用户名',
    password: '密码',
    keepAlive: '心跳（秒）',
    cleanSession: '清除会话',
    disconnect: '断开连接',
    currentState: '当前状态',
    // Subscribe
    subscribe: '订阅',
    topic: '主题',
    qoS: '服务质量',
    date: '订阅时间',
    oper: '操作',
    // Messages
    received: '收到',
    messages: '消息',
    retained: '保留',
    send: '发送',
    messagesAlreadySent: '发布消息列表',
    messagesReceived: '订阅消息列表',
    allmessagesReceived:'所有页面消息',
    allsubscribe:'所有页面订阅主题',
    time: '时间',
    connectError: '消息发送错误',
    connectFailure: '连接失败',
    connectLeave: '尚未连接到服务器',
    subscribeSuccess: '订阅成功',
    'mqtt connection failed, automatically reconnect':
      'mqtt连接失败，自动重连',
    subscribeFailure: '订阅失败',
    messageSendOut: '消息已发出',
    connected: '已连接',
    connecting: '正在连接',
    disconnected: '未连接',
    notSupport: '你的浏览器暂不支持WebSocket',
  }
}



// WEBPACK FOOTER //
// ./src/utils/i18.js